import { render, staticRenderFns } from "./DataDiscuss.vue?vue&type=template&id=619cab9d&scoped=true&"
import script from "./DataDiscuss.vue?vue&type=script&lang=js&"
export * from "./DataDiscuss.vue?vue&type=script&lang=js&"
import style0 from "./DataDiscuss.vue?vue&type=style&index=0&id=619cab9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619cab9d",
  null
  
)

export default component.exports